import { FC } from 'react';
import { IWebPlatformState } from './web-neobanking.state';
import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import PreviewSection from '@components/shared/preview-section/preview-section';
import FAQSection from '@components/shared/blocks/faq';
import SharedAnimation from '@components/shared/animation';
import animations from '@components/shared/animation/animations.module.scss';
import QuoteSection from '@components/shared/quote-section/quote-section';
import styles from './web-neobanking.module.scss';
import { Themes } from '@layouts/main-layout/themes.enum';
import PlatformOpportunities from './sections/platform-opportunities/platform-opportunities';
import WebCollaboration from './sections/coloboration/coloboration';
import TechnologyStack from './sections/technology-stack/technology-stack';
import HowItBegan from './sections/how-it-began/how-it-began';
import KeyFeatures from './sections/key-features/key-features';

interface WebNeobankingComponentProps {
  breadcrumbsText: string;
}

const WebNeobankingComponent: FC<WebNeobankingComponentProps> = ({ breadcrumbsText }) => {
  const { preview, platform, faq, services, keyFeatures, feedback, statistics, technologyStack } = IWebPlatformState;

  return (
    <>
      <Breadcrumbs lastElementTitle={breadcrumbsText} theme={Themes.Default} />
      <PreviewSection preview={preview} isDifferentColor={false} isCustomzePhoto={true} />
      <PlatformOpportunities platform={platform} />
      <WebCollaboration statistics={statistics} />
      <HowItBegan section={services} />
      <SharedAnimation
        render={(ref) => (
          <div ref={ref} className={`${styles.containerDifferent} ${animations.scroll__animation}`}>
            <FAQSection title={faq.title} itemsFAQ={faq.items} hoverColor={'grey'} />
          </div>
        )}
      />
      <TechnologyStack technologyStack={technologyStack} />
      <KeyFeatures keyFeatures={keyFeatures} />
      <QuoteSection section={feedback} isDifferentColor={true} />
    </>
  );
};

export default WebNeobankingComponent;
